export const DEFAULT_DESIGN_IMAGE = "/no-preview.jpeg";
